import * as React from 'react'
import MUIToolbar from '@mui/material/Toolbar'

const Toolbar = (props) => <MUIToolbar {...props} />

export default Toolbar
